import React from 'react';
import ContentLoader from 'react-content-loader';

const Loader = ({ width = '100%', height = 500 }) => (
  <ContentLoader
    speed={2}
    style={{ width, height }}
    backgroundcolor="#f3f3f3"
    foregroundcolor="#ecebeb"
  >
    <rect x="7%" y="45" rx="6" ry="6" width="40%" height="45" />
    <rect x="54%" y="45" rx="6" ry="6" width="40%" height="45" />

    <rect x="7%" y="100" rx="6" ry="6" width="40%" height="45" />
    <rect x="54%" y="100" rx="6" ry="6" width="40%" height="45" />

    <rect x="7%" y="155" rx="6" ry="6" width="40%" height="45" />
    <rect x="54%" y="155" rx="6" ry="6" width="40%" height="45" />

  </ContentLoader>
);

export default Loader;
